import { VehicleInfo } from '../types';
import { DealerLocationData } from '../hooks/useGetDealerDetails';

export const createMetaTitle = (
  vehicleData: VehicleInfo | undefined,
  dealerInfo: DealerLocationData | undefined,
) => {
  const vehicleType = vehicleData?.vehicleType;
  const vehicleNumber =
    vehicleType === 'non-audi' ? vehicleData?.stockNumber : vehicleData?.audiCode;
  const isNew = vehicleType === 'new';

  const type = isNew ? 'New' : 'Used';

  const usedDetails = `for sale in ${dealerInfo?.city}, ${dealerInfo?.region}`;
  const newDetails = `${vehicleData?.trimName} | ${vehicleData?.dealerName}`;

  const typeSpecificDetails = isNew ? newDetails : usedDetails;

  const title = vehicleData
    ? `${type} ${vehicleData?.modelName} ${typeSpecificDetails} | ${vehicleNumber}`
    : '';

  return title;
};
